/* eslint-disable react-hooks/exhaustive-deps */
import { debounce, get, isObject } from 'lodash';
import moment from 'moment';
import queryString from 'query-string';
import React, { useEffect, useRef, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import attachment from '../../../../assets/img/attachment.svg';
import { hideLoading, showLoading } from '../../../redux/loader/LoaderActions';
import { GET, PATCH, POST } from '../../../services/rest.service';

import Add from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ImportExport from '@mui/icons-material/ImportExport';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Switch from '@mui/material/Switch';
import $ from 'jquery';
import Select from 'react-select';
import { formatPhoneNumber } from '../../../helpers/helper';

const NanniesList = () => {
  const [records, setRecords] = useState([]);
  const [pages, setPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedIds, setSelectedIds] = useState([]);
  const [search, setSearch] = useState('');
  const [limit, setLimit] = useState(20);
  const [showTable, setShowTable] = useState(true);
  const [selectedSkills, setSelectedSkills] = useState(null);
  const [location, setLocation] = useState('');
  const [isSearchingLocation, setIsSearchingLocation] = useState(false);
  const [statusFilter, setStatusFilter] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const skills = useSelector((state) => state.skills);
  const prevLocationRef = useRef(window.location.search);

  const viewRecord = (record) => {
    navigate(`/admin/nanny/view/${record._id}`);
  };

  const editRecord = (record) => {
    navigate(`/admin/nanny/update/${record._id}`);
  };

  const createRecord = () => {
    navigate(`/admin/nanny/create`);
  };

  const deleteRecord = async (record, index) => {
    try {
      const result = await swal({
        title: 'Are you sure?',
        text: 'Are you sure you want to delete this nanny account? All their data will be lost forever.',
        icon: 'warning',
        buttons: ['No', 'Yes'],
      });
      if (result) {
        await PATCH(`/admin/user/change_status/${record._id}`, { status: 'Deleted' });
        setRecords([...records.slice(0, index), ...records.slice(index + 1)]);
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const toggleSwitch = async (record, index) => {
    record.status = record.status === 'Active' ? 'Inactive' : 'Active';
    try {
      const res = await PATCH(`/admin/user/change_status/${record._id}`, { status: record.status });
      const nannyRecord = res.data;
      setRecords(Object.assign([], records, { [index]: nannyRecord }));
    } catch (err) {
      toast.error(err.message);
    }
  };

  const markAsTop = async (record, index) => {
    try {
      const res = await PATCH(`/admin/nanny/top/${record._id}`);
      const nannyRecord = res.data;
      setRecords(Object.assign([], records, { [index]: nannyRecord }));
    } catch (err) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    let { page } = queryString.parse(window.location.search);

    if (page) {
      getPage(page);
    } else {
      getPage(1);
    }

    $(function () {
      $('.scroll-main').on('scroll', function () {
        $('.scroll-child').scrollLeft($('.scroll-main').scrollLeft());
      });
      $('.scroll-child').on('scroll', function () {
        $('.scroll-main').scrollLeft($('.scroll-child').scrollLeft());
      });
    });
  }, []);

  useEffect(() => {
    if (prevLocationRef.current !== window.location.search) {
      let { page } = queryString.parse(window.location.search);
      if (page) {
        getPage(page);
      } else {
        getPage(1);
      }
      prevLocationRef.current = window.location.search;
    }
  }, [window.location.search]);

  const handlePageClick = (e) => {
    const parsed = queryString.parse(window.location.search);
    parsed.page = e.selected + 1;

    navigate({
      pathname: `/admin/nanny/list`,
      search: queryString.stringify(parsed),
    });
  };

  const getPage = async (pageNumber) => {
    const queryParams = window.location.search;
    let { search, selectedSkills, location, statusFilter, selectedSkillsName, limit } = queryString.parse(queryParams);

    dispatch(showLoading());

    try {
      const { data } = await GET(`admin/nanny/get/${pageNumber}/${search || ''}`, {
        limit: limit || 20,
        skillId: isObject(selectedSkills) ? selectedSkills.value : selectedSkills ? selectedSkills || '' : '',
        location: location || '',
        status: isObject(statusFilter) ? statusFilter.value : statusFilter ? statusFilter : '',
      });
      setLimit(limit || 20);
      setRecords(data.Users);
      setPages(data.Pages);
      setTotal(data.Total);
      setCurrentPage(pageNumber);
      setShowTable(true);
      setSearch(search || '');
      setLocation(location || '');
      setSelectedSkills(isObject(selectedSkills) ? selectedSkills : selectedSkills ? { value: selectedSkills, label: selectedSkillsName } : '');
      setIsSearchingLocation(false);
      setStatusFilter(
        isObject(statusFilter)
          ? statusFilter
          : statusFilter
            ? [
                { label: 'Approve', value: 'Active' },
                { label: 'UnApprove', value: 'Inactive' },
              ].find((x) => x.value === statusFilter)
            : '',
      );
      dispatch(hideLoading());
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.message);
    }
  };

  const handleExport = async () => {
    const payload = {
      ids: selectedIds,
    };

    dispatch(showLoading('Exporting, please wait...'));
    try {
      const res = await POST(`/admin/nanny/export/pdf`, payload, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Nannies-Resume.pdf');
      document.body.appendChild(link);
      link.click();
      dispatch(hideLoading());
    } catch (err) {
      console.log('err', err);
      dispatch(hideLoading());
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const parsed = queryString.parse(window.location.search);
    parsed.search = search;
    parsed.page = 1;
    if (!parsed.search) {
      delete parsed.search;
    }
    navigate({
      pathname: `/admin/nanny/list`,
      search: queryString.stringify(parsed),
    });
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  useEffect(() => {
    const searchParams = {
      page: currentPage,
      selectedSkills: selectedSkills ? selectedSkills.value : '',
      selectedSkillsName: selectedSkills ? selectedSkills.label : '',
      statusFilter: statusFilter ? statusFilter.value : '',
      location: location || '',
    };

    Object.keys(searchParams).forEach((key) => searchParams[key] === '' && delete searchParams[key]);

    const searchString = queryString.stringify(searchParams);

    const searchHandler = () => {
      navigate({
        pathname: `/admin/nanny/list`,
        search: searchString,
      });
    };

    const debouncedSearch = debounce(searchHandler, 1000);

    if (location !== '' || selectedSkills || statusFilter) {
      debouncedSearch();
    }

    return () => {
      debouncedSearch.cancel();
    };
  }, [location, selectedSkills, statusFilter]);

  const handleLimitChange = (e) => {
    const parsed = queryString.parse(window.location.search);
    parsed.limit = e.target.value;
    parsed.page = 1;
    navigate({
      pathname: `/admin/nanny/list`,
      search: queryString.stringify(parsed),
    });
  };

  // const handleSkillChange = (selectedSkills) => {
  //   setSelectedSkills(isObject(selectedSkills) ? selectedSkills : null);
  // };

  const handleSkillChange = (selected) => {
    setSelectedSkills(isObject(selected) ? selected : null);

    const parsed = queryString.parse(window.location.search);
    if (selected) {
      parsed.selectedSkills = selected.value;
      parsed.selectedSkillsName = selected.label;
    } else {
      delete parsed.selectedSkills;
      delete parsed.selectedSkillsName;
    }
    parsed.page = 1;

    navigate({
      pathname: `/admin/nanny/list`,
      search: queryString.stringify(parsed),
    });
  };
  const handleOnChangeStatus = (statusFilter) => {
    setStatusFilter(isObject(statusFilter) ? statusFilter : null);
  };

  const handleChangeLocation = (e) => {
    setLocation(e.target.value);
    setIsSearchingLocation(true);
  };

  const skillsOptions =
    skills &&
    skills.map((x, index) => {
      return {
        value: x._id,
        label: x.title,
      };
    });
  return (
    <div className="container-fluid px-xl-5">
      <section className="py-5">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header d-md-flex justify-content-between align-items-center">
                <h6 className="text-uppercase mb-2 mb-md-0">Nannies</h6>

                <div className={'d-md-flex'}>
                  <div className={'mr-2 mb-2 mb-md-0'}>
                    <form onSubmit={handleSearch}>
                      <div className="input-group">
                        <input type="search" value={search} onChange={handleSearchChange} className="form-control" placeholder="Search..." />
                        <button className={'btn btn-light text-dark px-2 ml-2'} type="submit">
                          <i className="fa fa-search"></i>
                        </button>
                      </div>
                    </form>
                  </div>

                  <Button variant="outlined" color="secondary" onClick={createRecord}>
                    <Add />
                    Create
                  </Button>
                  <Button disabled={selectedIds.length === 0} variant="outlined" color="primary" className=" ml-2" onClick={handleExport}>
                    <ImportExport />
                    Export PDF
                  </Button>
                </div>
              </div>
              <div className="card-body">
                <div className="">
                  <div className="row">
                    <div className="col-12 col-md-6 col-lg-3 form-group">
                      <Select
                        value={selectedSkills}
                        isClearable={true}
                        placeholder="Select Skill"
                        options={skillsOptions}
                        onChange={handleSkillChange}
                        hideSelectedOptions={true}
                      />
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 form-group">
                      <div className="input-group searchbar">
                        <span className="ic-search">
                          <i className={`fa ${isSearchingLocation ? 'fas fa-spinner fa-spin' : 'fa-search'}`} />
                        </span>
                        <input type="text" name="Search-Location No" className="form-control" value={location} placeholder="Search by Location" onChange={handleChangeLocation} />
                      </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-3 form-group">
                      <Select
                        value={statusFilter}
                        isClearable={true}
                        placeholder="Select Status"
                        options={[
                          { label: 'Approve', value: 'Active' },
                          { label: 'UnApprove', value: 'Inactive' },
                        ]}
                        onChange={handleOnChangeStatus}
                        hideSelectedOptions={true}
                      />
                    </div>
                  </div>
                </div>
                <div className={'table-responsive table-scroll'}>
                  <div className="scroll-main">
                    <div className="scroll-main-inner"></div>
                  </div>
                  <div className="scroll-child">
                    <table className="table card-text scroll-child-inner">
                      <thead>
                        <tr>
                          <th>&nbsp;</th>
                          <th>#</th>
                          <th>Signup Date</th>
                          <th>Name</th>
                          <th>Type</th>
                          <th>Email</th>
                          <th>Location</th>
                          <th>Phone Number</th>
                          <th className="text-center">Approve Account</th>
                          <th className="text-center">Top Nanny</th>
                          <th className="text-center">
                            Email <br /> Confirmed?
                          </th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        {showTable &&
                          records.map((record, index) => {
                            return (
                              <tr key={index}>
                                <th>
                                  <Checkbox
                                    type="checkbox"
                                    color="secondary"
                                    name={record._id}
                                    value={record._id}
                                    checked={selectedIds.includes(record._id)}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setSelectedIds([...selectedIds, record._id]);
                                      } else {
                                        setSelectedIds(selectedIds.filter((cls) => cls !== record._id));
                                      }
                                    }}
                                  />
                                </th>
                                <th scope="row">{currentPage * 20 - 20 + (index + 1)}</th>

                                <th scope="row">{record?.created_at === undefined ? '-' : moment(record?.created_at).format('MM/DD/YYYY')}</th>
                                <td>
                                  {get(record, 'nannies.resume.document.name') && (
                                    <a href={get(record, 'nannies.resume.document.url')} rel="noopener noreferrer" target="_blank" className="mr-2">
                                      <img width="17" height="23" src={attachment} alt="attachment" />{' '}
                                    </a>
                                  )}

                                  <Link to={`/admin/nanny/view/${record._id}`}>
                                    {record.first_name}&nbsp;
                                    {record.last_name}
                                  </Link>
                                </td>
                                <td>{record?.type}</td>
                                <td>{record?.email}</td>
                                <td>{record?.location?.address}</td>
                                <td>{formatPhoneNumber(record.mobile_number)}</td>
                                <td className="text-center">
                                  <Switch color="secondary" onClick={() => toggleSwitch(record, index)} checked={record.status === 'Active'} />
                                </td>
                                <td className="text-center">
                                  {record.type !== 'Sitter' && (
                                    <Checkbox color="secondary" checked={record?.nannies?.top_nanny ? true : false} onChange={(e) => markAsTop(record, index)} />
                                  )}
                                </td>
                                <td className="text-center">{record.isEmailConfirmed ? 'Yes' : 'No'}</td>
                                <td className="text-center">
                                  <IconButton color="secondary" onClick={() => viewRecord(record)} aria-label="Delete">
                                    <VisibilityIcon />
                                  </IconButton>
                                  <IconButton color="primary" onClick={() => editRecord(record, index)} aria-label="Edit">
                                    <EditIcon />
                                  </IconButton>
                                  <IconButton color="secondary" onClick={() => deleteRecord(record, index)} aria-label="Delete">
                                    <DeleteIcon />
                                  </IconButton>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="float-right my-4">
                  <div className={'d-flex'}>
                    <label className={'mb-0'}>Select Page Size:</label>
                    <select className={'ml-2'} name="limit" id="pageLimitChanger" value={limit} onChange={handleLimitChange}>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={total}>All</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mx-auto my-4">
            <ReactPaginate
              previousLabel={'previous'}
              nextLabel={'next'}
              forcePage={currentPage - 1}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={pages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
              pageLinkClassName={'page-link'}
              previousClassName={'page-item'}
              nextClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextLinkClassName={'page-link'}
              pageClassName={'page-item'}
              onPageChange={handlePageClick}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default NanniesList;
